<template>
  <div class="text-white px-4 mb-5">
    <main>
      <section class="pt-5 ps-4">
        <div class="font-bold p-5 mb-3 text-4xl">Games</div>
        <p class="w-full md:w-100 px-5 pl-6 pb-5 text-md">
          MetX Games is where you can enjoy playing {{ label=='Testnet'?'and testing blockchain games in the ' + label + ' environment ':'' }}either on MetX Games or on your smartphone. You can then give feedback to the game developer of a game you played.
        </p>
      </section>
      <section class="px-4 pb-3">
        <div class="my-3 pl-2">New Invitations</div>
        <div v-if="displayGames">
        <div class="sm:grid xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 mb-4">
          <router-link :to="{ name: 'viewGamesDetails', params: { gameId: game.gameDto.gameId }}" class="hover:opacity-80 m-3 transform hover:-translate-y-2 transition-all duration-200 drop-shadow-xl" v-for="game, index in displayGames" :key="index">
            <div>
              <div class="card-img-top" v-if="game.gameDetailsDto.gallery.headerImage" :style="'background: url(' + assetURL + 'blob/games/' + game.gameDto.gameId + '/gallery/' + game.gameDetailsDto.gallery.headerImage + ') #000; background-repeat: no-repeat; background-size: cover;'" >
              </div>
              <div class="card-img-top" v-else :style="'background: url(' + require(`@/assets/images/default-cover-small.png`) + '); background-repeat: no-repeat; background-size: cover;'" >
              </div>
              <div class="bg-black-body p-2 truncate text-gray-text">
                <h6 class="text-sm text-white font-bold mb-0 truncate">{{ game.gameDto.title }}</h6>
                <div class="text-sm text-gray-text truncate h-5 display-block" v-if="game.gameDetailsDto.about.about == null"></div>
                <small class="text-sm text-gray-text truncate" v-html="game.gameDetailsDto.about.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)" v-else />
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else class="">
                You have no Invited games.
      </div>
        <router-link :to="{ name: 'viewGamersDashboard'}" class="btn-primary mx-3">Explore</router-link>
      </section>
    </main>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from "vue";
import { InviteUtils } from '@/utils/InviteUtils';
import { useStore } from "vuex";

export default defineComponent({
  name: "viewDashboard",
  setup(){
    const store = useStore();
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const games = ref([]);
    const displayGames = ref([]);
    const invitedGames = ref([]);
    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });

    (async() => {
      const gameInvitation = new InviteUtils();
      games.value = await gameInvitation.fetchInvitedGames();
      games.value.forEach(game => {
        if(game.gameDto != null){
          if(!invitedGames.value.includes(game.gameDto.gameId)){
            invitedGames.value.push(game.gameDto.gameId);
            displayGames.value.push(game);
          }
        }
      })
    })()
    return {
      games,
      label,
      assetURL,
      displayGames,
      invitedGames,
    }
  }
});
</script>

<style lang="scss" scoped>
.card-img-top {
  height: 150px !important;
}

</style>
